import React from 'react';

import GenericMeetingInfoComponent from './GenericMeetingInfoComponent';
import CollegiumMeetingInfoComponent from './CollegiumMeetingInfoComponent';
import VericelMeetingInfoComponent from './VericelMeetingInfoComponent';
import SklsiMeetingInfoComponent from './SklsiMeetingInfoComponent';

const regFormMapping = {
  collegium: CollegiumMeetingInfoComponent,
  vericel: VericelMeetingInfoComponent,
  sklsi: SklsiMeetingInfoComponent
};

const renderMeetingInfoComponent = (tenant) => {
  console.log('renderMeetingInfoComponent tenant', tenant);
  const MeetingInfoComponent = regFormMapping[tenant]
    ? regFormMapping[tenant]
    : GenericMeetingInfoComponent;
  return <MeetingInfoComponent tenant={tenant} />;
};

export default renderMeetingInfoComponent;
